import "../../../callout.js";
import "../../../mixins/recoverable_error.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.ConfirmationStep ??= {};

AppointmentBooking.Wizard.Views.ConfirmationStep.InvalidPatientTypeCallout = class InvalidPatientTypeCallout extends (
  AppointmentBooking.Wizard.Views.Mixins.RecoverableError(AppointmentBooking.Wizard.Views.Callout)
) {};
AppointmentBooking.Wizard.Views.ConfirmationStep.InvalidPatientTypeCallout.prototype.template =
  "step/confirmation/callouts/invalid_patient_type";
AppointmentBooking.Wizard.Views.ConfirmationStep.InvalidPatientTypeCallout.prototype.className =
  "appointment-booking-wizard-confirmation-step-invalid-patient-type-callout borderless";

AppointmentBooking.Wizard.Views.ConfirmationStep.InvalidPatientTypeCallout.prototype.recoverableErrorTypes = [
  "ehr_appointment_slot_id_invalid_patient_type_new_patient",
  "ehr_appointment_slot_id_invalid_patient_type_returning_patient",
];
